"use server";

import { redirect } from "next/navigation";
import bcrypt from "bcryptjs";
import { getUserByEmail } from "@/lib/users";
import { setSession, clearSession } from "@/lib/auth";

export async function loginAction(
  _prev: { error?: string } | undefined,
  formData: FormData
): Promise<{ error: string }> {
  const email = (formData.get("email") as string | null)?.trim() ?? "";
  const password = (formData.get("password") as string | null) ?? "";
  const from = (formData.get("from") as string | null) ?? "";

  if (!email || !password) {
    return { error: "Vyplňte e-mail a heslo." };
  }

  const user = getUserByEmail(email);
  if (!user || !user.active) {
    return { error: "Nesprávny e-mail alebo heslo." };
  }

  const ok = await bcrypt.compare(password, user.passwordHash);
  if (!ok) {
    return { error: "Nesprávny e-mail alebo heslo." };
  }

  await setSession({
    userId: user.id,
    role: user.role,
    permissions: user.permissions,
    name: user.name,
    email: user.email,
  });

  const dest =
    from && from.startsWith("/")
      ? from
      : user.role === "admin"
      ? "/admin"
      : "/partner/dashboard";

  redirect(dest);
}

export async function logoutAction(): Promise<void> {
  await clearSession();
  redirect("/login");
}
